export default {
  app: {
    notFound: {
      title: 'Pagina niet gevonden.',
      subtitle: 'Het lijkt erop dat je verdwaald bent.',
      text: 'Maak je geen zorgen, we helpen je vanaf hier te navigeren',
    },
  },
};
